import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WithdrawTabComponent } from 'src/app/pages/core/pages/user-dash/withdraw-tab/withdraw-tab.component';
import { ScrollStrategyOptions } from '@angular/cdk/overlay';

// Nose porque razon no le gusta el enum este
// eslint-disable-next-line no-shadow
enum Operation {
  COMPRA_CRYPTO,
  VENTA_CRYPTO,
  DEPOSITO,
  STAKING_DEPOSITO,
  STAKING_RETIRO,
}
class Info {
  coin: string; // DAI
  ticker: string; // DAI_USD (if currency is USD)
  operation: Operation;
  amount: number;
  currency: string;
  origAmount: number;
  from: string;
  isBundle: boolean;
}
@Component({
  selector: 'app-crypto-confirm-dialog',
  templateUrl: './crypto-confirm-dialog.component.html',
  styleUrls: ['./crypto-confirm-dialog.component.scss'],
})
export class CryptoConfirmDialogComponent implements OnInit {
  public title: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Info,
    private router: Router,
    private sso: ScrollStrategyOptions,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<CryptoConfirmDialogComponent>,
  ) {}

  ngOnInit(): void {
    switch (this.data.operation) {
      case Operation.COMPRA_CRYPTO:
        this.title = `Compra con éxito`;
        break;
      case Operation.VENTA_CRYPTO:
        this.title = `Venta con éxito`;
        break;
      case Operation.DEPOSITO:
        this.title = `Depósito recibido`;
        break;
      case Operation.STAKING_DEPOSITO:
        this.title = `Felicidades`;
        break;
      case Operation.STAKING_RETIRO:
        this.title = `Felicidades`;
        break;
    }
  }

  openWithdraw() {
    this.dialog.open(WithdrawTabComponent, {
      backdropClass: 'dialog-primary-backdrop',
      panelClass: 'deposit',
      width: '40%',
      maxWidth: '748px',
      minWidth: 'fit-content',
      scrollStrategy: this.sso.reposition({
        autoClose: false,
        scrollThrottle: 300,
      }),
      data: `${this.data.currency}-withdraw`,
    });
    this.dialogRef.close();
  }

  operationBtnClicked() {
    this.dialogRef.close(true);
    this.router.navigate(['/history']);
  }

  reviewBtnClicked() {
    window.open(
      `https://www.google.com/search?q=tiendacrypto&oq=tiendacrypto&aqs=edge..69i57j0i30l2j69i60l3.4044j0j1&sourceid=chrome&ie=UTF-8#lrd=0x95bccb2cb01b8213:0xbaefbe602d6e809e,3,,,,`,
      '_blank',
    );
  }
}
